import React from "react";
import AddIcon from "@mui/icons-material/Add";
import PictureAsPdf from "@mui/icons-material/PictureAsPdf";
import { ActionsButtons } from "components/CustomButtons/ActionsButtons";
import { MONTHLY_CLOSING_LABELS } from "./labels";
import { formatNumber } from "helpers/getNumberFormats";
import { useRuleValidator } from "hooks/useRuleValidator";
import { PERMISSIONS } from "router/permissions";

const { headers, tooltips } = MONTHLY_CLOSING_LABELS;

const MonthlyClosingActions = ({ original, onView, onDownloadReceipt }) => {
  const canView = useRuleValidator(PERMISSIONS.WITHHOLDINGS_CLOSING_VIEW);
  const buttons = [
    { Icon: AddIcon, color: 0, onClick: () => onView(original), tooltip: tooltips.newMovement, validation: canView && original?.monthlyBalance > 0 },
  ];
  return <ActionsButtons buttons={buttons} />;
};

export const columns = ({ onView, onDownloadReceipt }) => [
  {
    Header: headers.customerName,
    accessor: "customerName",
    filterable: true,
    filterMethod: (filter, row) =>
      String(row?.customerName || "").toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: headers.retentions,
    accessor: "retentions",
    filterable: true,
    Cell: ({ value }) => <div>$ {formatNumber(value)}</div>,
    filterMethod: (filter, row) =>
      String(row?.retentions || "").includes(filter.value),
  },
  {
    Header: headers.advances,
    accessor: "advances",
    filterable: true,
    Cell: ({ value }) => <div>$ {formatNumber(value)}</div>,
    filterMethod: (filter, row) =>
      String(row?.advances || "").includes(filter.value),
  },
  {
    Header: headers.others,
    accessor: "others",
    filterable: true,
    Cell: ({ value }) => <div>$ {formatNumber(value)}</div>,
    filterMethod: (filter, row) =>
      String(row?.others || "").includes(filter.value),
  },
  {
    Header: headers.close,
    accessor: "close",
    filterable: true,
    Cell: ({ value }) => <div>$ {formatNumber(value)}</div>,
    filterMethod: (filter, row) =>
      String(row?.close || "").includes(filter.value),
  },
  {
    Header: headers.monthlyTotal,
    accessor: "monthlyTotal",
    filterable: true,
    Cell: ({ value }) => <div>$ {formatNumber(value)}</div>,
    filterMethod: (filter, row) =>
      String(row?.monthlyTotal || "").includes(filter.value),
  },
  {
    Header: headers.actions,
    filterable: false,
    Cell: ({ original }) => (
      <MonthlyClosingActions original={original} onView={onView} onDownloadReceipt={onDownloadReceipt} />
    ),
  },
];

export const expenseColumns = [
  { Header: headers.createdDate, accessor: "createdDate" },
  { Header: headers.expense, accessor: "expense" },
  { Header: headers.amount, accessor: "amount" },
];
